module.exports = __webpack_public_path__ + "img/image68.f7d9bb8a.jpg";